module.exports = __webpack_public_path__ + "img/arrowDown.7ba448e1.svg";